import { Flex, Box, Tooltip } from '@chakra-ui/react';

import { useMarkAsReadMutation } from '@/store/query/notification';
import { useState, createContext, useContext } from 'react';
import { useKFlags } from '@/hooks/use-k-flags';

const NotificationCardManager = createContext({
  markAsRead: () => {},
});

NotificationCardManager.displayName = 'NotificationCardManager';

export const useNotificationCard = () => {
  const contextValue = useContext(NotificationCardManager);
  const { markAsRead } = contextValue;
  return {
    markAsRead,
  };
};
const NotificationProvider = NotificationCardManager.Provider;

export const NotificationCard = ({
  children,
  notification,
  skipMark = false,
  background = '',
}) => {
  const { ats_enabled } = useKFlags();
  const [markAsRead] = useMarkAsReadMutation();
  const [value, setValue] = useState(!Boolean(notification.read_at));

  const onMarkAsRead = async () => {
    try {
      const result = await markAsRead({ id: notification?.id });
      if (result?.data?.read_at) {
        setValue(false);
      }
    } catch {}
  };

  return (
    <NotificationProvider
      value={{
        markAsRead: onMarkAsRead,
      }}
    >
      <Flex
        borderBottom="1px solid #E5E5E5"
        p="20px 12px"
        data-test-id="in-app-notification-card"
        background={background}
      >
        <Box flex="1">{children}</Box>

        {!skipMark && (
          <Box width="40px" onClick={onMarkAsRead} ml="8px" pt="12px" pl="12px">
            {value && (
              <Tooltip
                label="Mark as read"
                shouldWrapChildren
                hasArrow
                placement="right"
                arrowSize={8}
                borderRadius="3px"
                bg="#161616"
              >
                <Box
                  cursor="pointer"
                  width="10px"
                  height="10px"
                  bg={
                    value ? (ats_enabled ? 'ats-primary' : '#0043CE') : '#FFF'
                  }
                  borderRadius="full"
                />
              </Tooltip>
            )}
          </Box>
        )}
      </Flex>
    </NotificationProvider>
  );
};
